// Загрузка доступных устройств
export const EVENTS_DEVICES_REQUEST =
    "events/DEVICES_REQUEST";

export const EVENTS_DEVICES_SUCCESS =
    "events/DEVICES_SUCCESS";

export const EVENTS_DEVICES_FAILURE =
    "events/DEVICES_FAILURE";

// Загрузка событий
export const EVENTS_DATA_REQUEST =
    "events/DATA_REQUEST";

export const EVENTS_DATA_SUCCESS =
    "events/DATA_SUCCESS";

export const EVENTS_DATA_FAILURE =
    "events/DATA_FAILURE";

// Применение фильтра
export const EVENTS_FILTER_APPLY =
    "events/FILTER_APPLY";

// Очистка состояния страницы
export const EVENTS_RESET = "events/RESET";
